import { useTranslation } from "react-i18next";
import { usePageTitle } from "@/hooks/usePageTitle";
import type { projectIdKey } from "@/routes/company/routes.projects.constants";
import { useParams } from "react-router-dom";
import { ProjectOKRTable } from "./project-okr-table";
import { withBranding } from "@/utils/helper";

export const TabProjectOKRs = () => {
  const { t } = useTranslation(["projects", "common"]);
  usePageTitle(withBranding(t("projects:project_okrs")));
  const { projectId } = useParams<{ [projectIdKey]: string }>();

  if (!projectId) return <p>{t("projects:project_not_found")}</p>;
  return <ProjectOKRTable projectId={projectId} />;
};
